import { makeAutoObservable } from 'mobx'
import type { CompanyListItem, LoginRepsData } from '@/servers/user/types'
import { countryEnum } from '@/const'

export const defaultSelectedCompanyInfo: CompanyListItem = {
  company_ex_id: '',
  menu_list: [],
  name: '',
  not_direct: false,
  is_company_admin: 0,
  level: 2,
  balance: 0,
  status: 0,
  pay_type: 0
}

export const defaultUserInfo: LoginRepsData = {
  menu_info: [],
  name: '',
  phone: '',
  email: '',
  status: 0,
  super: 0,
  user_id: '',
  token: '',
  profile_photo: ''
}

class UserStore {
  userInfo: LoginRepsData = defaultUserInfo
  companyList: CompanyListItem[] = []
  selectedCompanyInfo: CompanyListItem = defaultSelectedCompanyInfo
  selectedCountry = countryEnum.CN
  showLoginModal = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  commitUpdateAction<T extends (store: UserStoreT) => any>(updater: T): ReturnType<T> {
    return updater(this)
  }

  updateSelectedCompanyInfo = (info: CompanyListItem) => {
    this.selectedCompanyInfo = info
  }
}

export type UserStoreT = InstanceType<typeof UserStore>
export default new UserStore()
